import { render, staticRenderFns } from "./TeachQualification.vue?vue&type=template&id=5b104b37&scoped=true&"
import script from "./TeachQualification.vue?vue&type=script&lang=js&"
export * from "./TeachQualification.vue?vue&type=script&lang=js&"
import style0 from "./TeachQualification.vue?vue&type=style&index=0&id=5b104b37&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b104b37",
  null
  
)

export default component.exports